import desktopDimensions from "./dimensions.desktop";
import mobileDimensions from "./dimensions.mobile";
import tabletDimensions from "./dimensions.tablet";

let Dimensions = null;

// #!if mobile === true
// Dimensions = mobileDimensions;
// #!elseif tablet === true
// Dimensions = tabletDimensions;
// #!else
Dimensions = desktopDimensions;
// #!endif

export default Dimensions;

// Scale a value by the changed font size
export const scalePixelsToFontSize = (p, fontSize, shouldRound = false) => {
  const value = (p * fontSize) / Dimensions.BASE_FONT_SIZE;
  return shouldRound ? Math.round(value) : value;
};

export const scaleBackPixelsToFontSize = (p, fontSize, shouldRound = false) => {
  const value = (p * Dimensions.BASE_FONT_SIZE) / fontSize;
  return shouldRound ? Math.round(value) : value;
};

const MAX_TITLE_FONT_SIZE = 17;
const MIN_TITLE_FONT_SIZE = 13;

export const getFontSizeInRangeLimit = fontSize => {
  let result = fontSize;
  //#!if iOS === true
// result = Math.min(Math.max(fontSize, MIN_TITLE_FONT_SIZE), MAX_TITLE_FONT_SIZE);
  //#!endif
  return result;
};
